import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Download, X } from 'lucide-react';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      const dismissed = sessionStorage.getItem('pwa-dismissed');
      if (!dismissed) setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShowBanner(false);
    setDeferredPrompt(null);
  };

  const dismiss = () => {
    setShowBanner(false);
    sessionStorage.setItem('pwa-dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 animate-fadeIn" data-testid="install-prompt">
      <div className="bg-bg-secondary border border-gold/20 rounded-sm p-4 flex items-center justify-between max-w-md mx-auto shadow-lg shadow-black/50">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-sm bg-gold/10 flex items-center justify-center">
            <Download className="w-4 h-4 text-gold" />
          </div>
          <div>
            <p className="text-white font-sans text-sm font-medium">Install Majnu</p>
            <p className="text-zinc-500 font-sans text-xs">Quick access from your home screen</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button size="sm" onClick={install} className="bg-gold text-black font-bold rounded-sm font-sans text-xs h-8" data-testid="install-button">Install</Button>
          <button onClick={dismiss} className="text-zinc-500 hover:text-zinc-400 p-1" data-testid="dismiss-install"><X className="w-4 h-4" /></button>
        </div>
      </div>
    </div>
  );
}
